import {
  CLEAR_INCOMPLETE_COMPANY_ID,
  SAVE_INCOMPLETE_COMPANY_ID,
  SET_COMMON_WIDTH,
  SET_LOGIN_PATH,
  SET_VERSION,
  SWITCH_CONTEXT,
} from '../actions';

const defaultState = {
  contentAreaWidth: '100%',
  loginPath: '',
  version: '',
  incompleteId: '', // companyId with pending payment
};

export function app(state = defaultState, action = null) {
  switch (action.type) {
    case SET_COMMON_WIDTH: {
      return { ...state, contentAreaWidth: action.width };
    }
    case SAVE_INCOMPLETE_COMPANY_ID: {
      return { ...state, incompleteId: action.id };
    }
    case CLEAR_INCOMPLETE_COMPANY_ID: {
      return { ...state, incompleteId: '' };
    }
    case SET_LOGIN_PATH: {
      return { ...state, loginPath: action.value };
    }
    case SET_VERSION: {
      return { ...state, version: action.version };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/app.js